module.exports = new __parcel__URL__("docker.cc9966f6.svg").toString();